export const CMAIL = 'CMAIL';

const CategoryType = {
  SUBMISSION: 'SUBMISSION',
  CLAIMS: 'CLAIMS',
};

export enum EmailType {
  NEW = 'NEW',
  REPLY = 'REPLY',
  FORWARD = 'FORWARD',
  FOLLOWUP = 'FOLLOWUP',
}
